import { CONSTS } from 'config/objectConst'

const defaultNewAction = {
	open: true,
	validation: {
		actionName: true,
		period: true,
		textarea: true
	},
	values: {
		currentEmotion: 'Like',
		emotion: CONSTS.EMOTION,
		launchActionIn: 0,
		mainCustomFields: CONSTS.MAIN_CUSTOM_FIELDS,
		overflowCustomFields: CONSTS.OVERFLOW_CUSTOM_FIELDS,

		sendMessageTo: 'Contacts, who never replied',
		textarea: ''
	}
}

export { defaultNewAction }
